export const normalizeSearchTerm = (searchTerm: string): string => {
  // Will handle only product numbers with spaces in between
  // later when factfinder is ready we can use wildcard with product numbers less than 6 digits
  const searchTermWithoutSpaces = searchTerm.replace(/\s/g, '')
  const isValidProductNumber = /^[0-9]{6}$/.test(searchTermWithoutSpaces)
  if (isValidProductNumber) {
    return searchTermWithoutSpaces
  }
  return searchTerm
}
